import { CardLayout } from '@blinq-types';
import { createExampleCard, generateFieldID } from '@modules/card-helpers';

export const onboardingExampleCard = createExampleCard({
  color: '#35393B',
  layout: CardLayout.Layout_3A,
  emails: [
    {
      id: generateFieldID(),
      label: 'Work email',
      value: 'roy@nodexis.com',
      isPreset: false,
    },
  ],
  firstName: 'Roy',
  lastName: 'McAllister',
  jobTitle: 'Head of Engineering',
  orgName: 'NODEXIS',
  urls: [
    {
      type: 'org',
      title: 'nodexis.com',
      value: 'https://nodexis.com',
      userValue: 'https://nodexis.com',
      isPreset: false,
      id: generateFieldID(),
    },
    {
      type: 'instagram',
      title: '@roynodexis',
      value: 'https://instagram.com/roynodexis',
      userValue: 'https://instagram.com/roynodexis',
      isPreset: false,
      id: generateFieldID(),
    },
  ],
  phoneNumbers: [
    {
      label: 'Mobile',
      value: '(646) 555-0224',
      isPreset: false,
      id: generateFieldID(),
    },
  ],
  profilePictureImg: {
    originalImageUrl: '/img/onboarding/profile.png',
    editedImageUrl: '/img/onboarding/profile.png',
  },
  companyLogoImg: {
    originalImageUrl: '/img/onboarding/logo.png',
    editedImageUrl: '/img/onboarding/logo.png',
  },
  coverPhotoImg: {
    originalImageUrl: '/img/onboarding/cover.png',
    editedImageUrl: '/img/onboarding/cover.png',
  },
});
